import axios from 'axios';

const companyUrl = process.env.REACT_APP_API_COMPANY;

export const contactUs = async (message: string): Promise<void> => {
  await axios.post(`${companyUrl}/api/contact-us`, { message });
};
